import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DataTableForm from '@/components/data-tables/DataTableForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import { DataTablesActions, DataTablesState } from '@/stores/data-tables.store';
import { DataTable } from '@/models/data-table.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'DataTablesList',
  setup(__props) {

const store = useStore<ShiftCMSState & { ds: DataTablesState }>();
const dataTables = computed<DataTable[]>(() => store.state.ds.dataTables);

const update = () => {
  store.dispatch(DataTablesActions.GetDataTables);
};

onMounted(() => {
  update();
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
});

const editDataTable = (_: Event, { item }: { item: DataTable }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(DataTableForm),
    data: item,
  });
};

const addDataTable = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(DataTableForm) });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Name', key: 'name', width: '10%' },
  { title: 'Data', key: 'data' },
  { title: 'Date', key: 'creationDate', width: '20%' },
];

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Data Tables", -1)),
      _createVNode(_component_v_alert, {
        type: "warning",
        density: "compact",
        class: "mb-8 mt-8"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Please be careful editing this data. It is used in the CO2 calculations.")
        ])),
        _: 1
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editDataTable,
        headers: headers,
        items: dataTables.value,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.creationDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'do MMMM yyyy - HH:mm')), 1)
        ]),
        "item.data": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(Array.isArray(value)
            ? `${value.length} rows`
            : `${Object.keys(value).length} fields`), 1)
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addDataTable,
        color: "success"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Add DataTable")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})